<div class="onboarding-page-shell">
  <!-- 1. HEADER STICKY DE 4 FASES -->
  <header
    class="onboarding-sticky-header"
    aria-label="Progreso general del proceso de onboarding y registro"
  >
    <div class="onboarding-header-inner">
      <div class="onboarding-phase-grid">
        <!-- Fase 1 -->
        <div
          class="onboarding-phase-col"
          [class.active]="currentPhase === 1"
          [class.completed]="isPhaseDone(1)"
          (click)="goToPhase(1)"
          style="cursor: pointer;"
        >
          <div class="onboarding-col-title-row">
            <span class="onboarding-phase-tag">
              {{ isPhaseDone(1) ? '✓ 01 Perfil' : '01 Perfil' }}
            </span>
            <span class="onboarding-phase-status-text">
              {{ getPhaseStatusText(1) }}
            </span>
          </div>
          <div class="onboarding-bar-track">
            <div
              class="onboarding-bar-fill"
              [class.fill-green]="isPhaseDone(1)"
              [class.fill-navy]="!isPhaseDone(1)"
              [style.width.%]="getPhaseProgress(1)"
            ></div>
          </div>
          <div class="onboarding-subsegments">
            @for (sub of getPhaseSubsections(1); track sub.id; let sIdx = $index) {
              <div
                class="segment-pill"
                [title]="sub.label"
                [class.green]="isPhaseDone(1) || getSubsectionProgress(1, sIdx) === 100"
                [class.navy]="!isPhaseDone(1) && currentPhase === 1 && getSubsectionProgress(1, sIdx) > 0"
              >
                <div
                  class="segment-pill-inner"
                  [style.width.%]="getSubsectionProgress(1, sIdx)"
                  [class.fill-green]="isPhaseDone(1) || getSubsectionProgress(1, sIdx) === 100"
                  [class.fill-navy]="!isPhaseDone(1) && getSubsectionProgress(1, sIdx) < 100"
                ></div>
              </div>
            }
          </div>
        </div>

        <!-- Fase 2 -->
        <div
          class="onboarding-phase-col"
          [class.active]="currentPhase === 2"
          [class.completed]="isPhaseDone(2)"
          (click)="goToPhase(2)"
          style="cursor: pointer;"
        >
          <div class="onboarding-col-title-row">
            <span class="onboarding-phase-tag">
              {{ isPhaseDone(2) ? '✓ 02 Inducción' : '02 Inducción' }}
            </span>
            <span class="onboarding-phase-status-text">
              {{ getPhaseStatusText(2) }}
            </span>
          </div>
          <div class="onboarding-bar-track">
            <div
              class="onboarding-bar-fill"
              [class.fill-green]="isPhaseDone(2)"
              [class.fill-navy]="!isPhaseDone(2)"
              [style.width.%]="getPhaseProgress(2)"
            ></div>
          </div>
          <div class="onboarding-subsegments">
            @for (sub of getPhaseSubsections(2); track sub.id; let sIdx = $index) {
              <div
                class="segment-pill"
                [title]="sub.label"
                [class.green]="isPhaseDone(2) || getSubsectionProgress(2, sIdx) === 100"
                [class.navy]="!isPhaseDone(2) && currentPhase === 2 && getSubsectionProgress(2, sIdx) > 0"
              >
                <div
                  class="segment-pill-inner"
                  [style.width.%]="getSubsectionProgress(2, sIdx)"
                  [class.fill-green]="isPhaseDone(2) || getSubsectionProgress(2, sIdx) === 100"
                  [class.fill-navy]="!isPhaseDone(2) && getSubsectionProgress(2, sIdx) < 100"
                ></div>
              </div>
            }
          </div>
        </div>

        <!-- Fase 3 -->
        <div
          class="onboarding-phase-col"
          [class.active]="currentPhase === 3"
          [class.completed]="isPhaseDone(3)"
          (click)="goToPhase(3)"
          style="cursor: pointer;"
        >
          <div class="onboarding-col-title-row">
            <span class="onboarding-phase-tag">
              {{ isPhaseDone(3) ? '✓ 03 Sobre Mí' : '03 Sobre Mí' }}
            </span>
            <span class="onboarding-phase-status-text">
              {{ getPhaseStatusText(3) }}
            </span>
          </div>
          <div class="onboarding-bar-track">
            <div
              class="onboarding-bar-fill"
              [class.fill-green]="isPhaseDone(3)"
              [class.fill-navy]="!isPhaseDone(3)"
              [style.width.%]="getPhaseProgress(3)"
            ></div>
          </div>
          <div class="onboarding-subsegments">
            @for (sub of getPhaseSubsections(3); track sub.id; let sIdx = $index) {
              <div
                class="segment-pill"
                [title]="sub.label"
                [class.green]="isPhaseDone(3) || getSubsectionProgress(3, sIdx) === 100"
                [class.navy]="!isPhaseDone(3) && currentPhase === 3 && getSubsectionProgress(3, sIdx) > 0"
              >
                <div
                  class="segment-pill-inner"
                  [style.width.%]="getSubsectionProgress(3, sIdx)"
                  [class.fill-green]="isPhaseDone(3) || getSubsectionProgress(3, sIdx) === 100"
                  [class.fill-navy]="!isPhaseDone(3) && getSubsectionProgress(3, sIdx) < 100"
                ></div>
              </div>
            }
          </div>
        </div>

        <!-- Fase 4 -->
        <div
          class="onboarding-phase-col"
          [class.active]="currentPhase === 4"
          [class.completed]="isPhaseDone(4)"
          (click)="goToPhase(4)"
          style="cursor: pointer;"
        >
          <div class="onboarding-col-title-row">
            <span class="onboarding-phase-tag">
              {{ isPhaseDone(4) ? '✓ 04 Documentos' : '04 Documentos' }}
            </span>
            <span class="onboarding-phase-status-text">
              {{ getPhaseStatusText(4) }}
            </span>
          </div>
          <div class="onboarding-bar-track">
            <div
              class="onboarding-bar-fill"
              [class.fill-green]="isPhaseDone(4)"
              [class.fill-navy]="!isPhaseDone(4)"
              [style.width.%]="getPhaseProgress(4)"
            ></div>
          </div>
          <div class="onboarding-subsegments">
            @for (sub of getPhaseSubsections(4); track sub.id; let sIdx = $index) {
              <div
                class="segment-pill"
                [title]="sub.label"
                [class.green]="isPhaseDone(4) || getSubsectionProgress(4, sIdx) === 100"
                [class.navy]="!isPhaseDone(4) && currentPhase === 4 && getSubsectionProgress(4, sIdx) > 0"
              >
                <div
                  class="segment-pill-inner"
                  [style.width.%]="getSubsectionProgress(4, sIdx)"
                  [class.fill-green]="isPhaseDone(4) || getSubsectionProgress(4, sIdx) === 100"
                  [class.fill-navy]="!isPhaseDone(4) && getSubsectionProgress(4, sIdx) < 100"
                ></div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- 2. CONTENEDOR PRINCIPAL CON OUTLINE INTELIGENTE -->
  <div class="onboarding-main-container">
    <div class="onboarding-two-col-grid">
      <!-- OUTLINE INTELIGENTE -->
      <aside
        class="onboarding-outline-aside sticky-aside"
        aria-label="Índice de secciones de la fase actual"
      >
        <div class="onboarding-outline-card">
          <div class="outline-header-label">SECCIONES · FASE 0{{ currentPhase }}</div>
          <ul class="onboarding-outline-list">
            @for (item of outlineItems; track item.id; let idx = $index) {
              <li>
                <button
                  type="button"
                  class="outline-step-btn"
                  [class.active]="activeSectionIndex === idx"
                  [class.completed-step]="isSectionCompleted(item.targetId, idx)"
                  (click)="scrollToSection(item.targetId, idx)"
                  (keydown)="handleOutlineKeyDown($event, item.targetId, idx)"
                  [title]="item.label"
                >
                  <span class="outline-indicator-bar"></span>
                  <span class="outline-text">{{ item.label }}</span>
                </button>
              </li>
            }
          </ul>
        </div>
      </aside>

      <!-- FORMULARIO PRINCIPAL -->
      <main class="onboarding-card">
        <form
          #phaseForm
          (ngSubmit)="onSubmitPhase()"
          (keydown)="handleFormKeyDown($event)"
          novalidate
        >
          <!-- BANNER DE CAMPOS FALTANTES -->
          @if (missingFieldsSummary.length > 0) {
            <div
              id="missing-fields-summary-alert"
              class="validation-alert-banner"
              role="alert"
              aria-live="polite"
              style="margin-bottom: 20px; padding: 14px 18px; border-radius: 12px; background: #fff1f2; border: 1.5px solid #fecdd3; color: #9f1239;"
            >
              <div style="display: flex; align-items: center; gap: 8px; font-weight: 800; font-size: 14px;">
                <span class="material-symbols-outlined" style="font-size: 20px; color: #e11d48;">warning</span>
                <span>
                  {{ missingFieldsSummary.length === 1
                    ? 'Falta 1 campo obligatorio para avanzar:'
                    : ('Faltan ' + missingFieldsSummary.length + ' campos obligatorios para avanzar:') }}
                </span>
              </div>
              <ul style="margin: 8px 0 0 24px; padding: 0; font-size: 13px;">
                @for (item of missingFieldsSummary; track item.key) {
                  <li style="margin-bottom: 4px;">
                    <a
                      href="javascript:void(0)"
                      (click)="focusField(item.inputId)"
                      style="color: #be123c; font-weight: 700; text-decoration: underline;"
                    >
                      {{ item.label }}
                    </a>
                    — {{ item.reason }}
                  </li>
                }
              </ul>
            </div>
          }

          @if (backendErrorMsg) {
            <div
              class="validation-alert-banner"
              role="alert"
              style="margin-bottom: 20px; padding: 14px 18px; border-radius: 12px; background: #fef2f2; border: 1.5px solid #fca5a5; color: #991b1b;"
            >
              <div style="display: flex; align-items: center; gap: 8px; font-weight: 800; font-size: 14px;">
                <span class="material-symbols-outlined" style="color: #dc2626; font-size: 20px;">report</span>
                <span>Error al registrar en base de datos: {{ backendErrorMsg }}</span>
              </div>
            </div>
          }

          <!-- =========================================================
               FASE 1: DATOS PERSONALES Y ACADÉMICOS / PROFESIONALES
               ========================================================= -->
          @if (currentPhase === 1) {
            <div class="onboarding-card-header">
              <h1 class="onboarding-card-title">
                {{ p1.userType === 'SS' ? 'Perfil Académico' : 'Perfil y Formación' }}
              </h1>
              <p class="onboarding-card-subtitle">
                Completa los datos esenciales para estructurar tu expediente institucional y habilitar las fases posteriores del sistema.
              </p>
            </div>

            <!-- Sección 1: Creación de cuenta -->
            <fieldset id="sec-account" class="onboarding-fieldset">
              <legend class="onboarding-fieldset-legend" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                <span>01 Creación de cuenta</span>
                <span
                  class="section-saved-indicator"
                  [class.status-saving]="getSectionStatus('account') === 'saving'"
                  [class.status-saved]="getSectionStatus('account') === 'saved'"
                  [class.status-error]="getSectionStatus('account') === 'error'"
                  [title]="getSectionStatusTitle('account')"
                >
                  <span class="material-symbols-outlined">{{ getSectionIcon('account') }}</span>
                  <span>{{ getSectionLabel('account') }}</span>
                </span>
              </legend>
              <div class="onboarding-fields-grid-2">
                <div>
                  <label class="abaq-label" for="p1-email">
                    {{ p1.userType === 'SS' ? 'Correo electrónico institucional (.edu.mx)' : 'Correo electrónico personal' }}
                    <span class="text-required">*</span>
                  </label>
                  <input
                    id="p1-email"
                    name="email"
                    type="email"
                    class="abaq-input"
                    [class.input-invalid]="invalidFields['email']"
                    [(ngModel)]="p1.email"
                    (ngModelChange)="onFieldChange('email', 'account')"
                    [placeholder]="p1.userType === 'SS' ? 'carlos.morales@alumnos.uaq.edu.mx' : 'andres.navarro@gmail.com'"
                  />
                  <span style="font-size: 11.5px; color: #64748b; margin-top: 4px; display: block;">
                    {{ p1.userType === 'SS' ? 'Usa tu correo institucional universitario (.edu.mx, ej. alumnos.uaq.edu.mx o itq.edu.mx).' : 'Usa tu correo personal para avisos y acceso al sistema.' }}
                  </span>
                  @if (invalidFields['email']) {
                    <span class="field-error-text">⚠️ {{ invalidFields['email'] }}</span>
                  }
                </div>

                <div>
                  <label class="abaq-label" for="p1-password">
                    Contraseña <span class="text-required">*</span>
                  </label>
                  <div style="position: relative; display: flex; align-items: center;">
                    <input
                      id="p1-password"
                      name="password"
                      [type]="showPassword ? 'text' : 'password'"
                      class="abaq-input"
                      style="padding-right: 78px;"
                      [class.input-invalid]="invalidFields['password']"
                      [(ngModel)]="p1.password"
                      (ngModelChange)="onFieldChange('password', 'account')"
                      placeholder="••••••••••••"
                    />
                    <button
                      type="button"
                      (click)="showPassword = !showPassword"
                      style="position: absolute; right: 10px; background: none; border: none; color: #24366f; font-size: 12px; font-weight: 700; cursor: pointer;"
                    >
                      {{ showPassword ? 'Ocultar' : 'Mostrar' }}
                    </button>
                  </div>
                  <span style="font-size: 11.5px; color: #64748b; margin-top: 4px; display: block;">
                    Mínimo 8 caracteres alfanuméricos.
                  </span>
                  @if (invalidFields['password']) {
                    <span class="field-error-text">⚠️ {{ invalidFields['password'] }}</span>
                  }
                </div>
              </div>
            </fieldset>

            <!-- Sección 2: Datos personales -->
            <fieldset id="sec-personal" class="onboarding-fieldset">
              <legend class="onboarding-fieldset-legend" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                <span>02 Datos personales</span>
                <span
                  class="section-saved-indicator"
                  [class.status-saving]="getSectionStatus('personal') === 'saving'"
                  [class.status-saved]="getSectionStatus('personal') === 'saved'"
                  [class.status-error]="getSectionStatus('personal') === 'error'"
                  [title]="getSectionStatusTitle('personal')"
                >
                  <span class="material-symbols-outlined">{{ getSectionIcon('personal') }}</span>
                  <span>{{ getSectionLabel('personal') }}</span>
                </span>
              </legend>
              <div class="onboarding-fields-grid-3">
                <div>
                  <label class="abaq-label" for="p1-names">
                    Nombre(s) <span class="text-required">*</span>
                  </label>
                  <input
                    id="p1-names"
                    name="names"
                    type="text"
                    class="abaq-input"
                    [class.input-invalid]="invalidFields['names']"
                    [(ngModel)]="p1.names"
                    (ngModelChange)="onFieldChange('names', 'personal')"
                    placeholder="Ej. Carlos Eduardo"
                  />
                  @if (invalidFields['names']) {
                    <span class="field-error-text">⚠️ {{ invalidFields['names'] }}</span>
                  }
                </div>

                <div>
                  <label class="abaq-label" for="p1-apellidoPaterno">
                    Apellido Paterno <span class="text-required">*</span>
                  </label>
                  <input
                    id="p1-apellidoPaterno"
                    name="apellidoPaterno"
                    type="text"
                    class="abaq-input"
                    [class.input-invalid]="invalidFields['apellidoPaterno']"
                    [(ngModel)]="p1.apellidoPaterno"
                    (ngModelChange)="onFieldChange('apellidoPaterno', 'personal')"
                    placeholder="Ej. Morales"
                  />
                  @if (invalidFields['apellidoPaterno']) {
                    <span class="field-error-text">⚠️ {{ invalidFields['apellidoPaterno'] }}</span>
                  }
                </div>

                <div>
                  <label class="abaq-label" for="p1-apellidoMaterno">
                    Apellido Materno
                  </label>
                  <input
                    id="p1-apellidoMaterno"
                    name="apellidoMaterno"
                    type="text"
                    class="abaq-input"
                    [(ngModel)]="p1.apellidoMaterno"
                    (ngModelChange)="onFieldChange('apellidoMaterno', 'personal')"
                    placeholder="Ej. Vargas"
                  />
                </div>
              </div>

              <div class="onboarding-fields-grid-2" style="margin-top: 14px;">
                <div>
                  <label class="abaq-label" for="p1-birthdate">
                    Fecha de nacimiento <span class="text-required">*</span>
                  </label>
                  <app-custom-datepicker
                    id="p1-birthdate"
                    name="birthDate"
                    [(ngModel)]="p1.birthDate"
                    [invalid]="!!invalidFields['birthDate']"
                    (valueChange)="onFieldChange('birthDate', 'personal')"
                    placeholder="DD/MM/AAAA"
                  ></app-custom-datepicker>
                  <span style="font-size: 11.5px; color: #64748b; margin-top: 4px; display: block;">
                    Escribe solo los números (sin guiones ni diagonales /); el sistema colocará las diagonales automáticamente. También puedes elegir la fecha en el calendario.
                  </span>
                  @if (invalidFields['birthDate']) {
                    <span class="field-error-text">⚠️ {{ invalidFields['birthDate'] }}</span>
                  }
                </div>

                <div>
                  <label class="abaq-label" for="p1-phone">
                    Teléfono celular principal <span class="text-required">*</span>
                  </label>
                  <input
                    id="p1-phone"
                    name="phone"
                    type="tel"
                    maxlength="14"
                    class="abaq-input"
                    [class.input-invalid]="invalidFields['phone']"
                    [ngModel]="p1.phone"
                    (ngModelChange)="onPhoneChange('phone', $event)"
                    placeholder="442 512 8840"
                  />
                  <span style="font-size: 11.5px; color: #64748b; margin-top: 4px; display: block;">
                    10 dígitos.
                  </span>
                  @if (invalidFields['phone']) {
                    <span class="field-error-text">⚠️ {{ invalidFields['phone'] }}</span>
                  }
                </div>
              </div>

              <!-- Casillas de WhatsApp y Segundo Contacto (Fiel al React Mockup) -->
              <div
                style="background: #f8fafc; border-radius: 14px; padding: 16px 20px; margin: 16px 0; border: 1px solid #e2e8f0; display: flex; flexDirection: column; gap: 14px;"
              >
                <!-- Casilla 1: WhatsApp -->
                <div>
                  <label style="display: flex; align-items: center; gap: 10px; cursor: pointer; user-select: none;">
                    <input
                      type="checkbox"
                      name="hasWhatsapp"
                      [(ngModel)]="p1.hasWhatsapp"
                      (ngModelChange)="onFieldChange('hasWhatsapp', 'personal')"
                      style="width: 18px; height: 18px; accent-color: #5ca83a; cursor: pointer;"
                    />
                    <span style="font-size: 13.5px; font-weight: 700; color: #24366f;">
                      Este número telefónico cuenta con WhatsApp activo
                    </span>
                  </label>

                  @if (!p1.hasWhatsapp) {
                    <div style="margin-top: 12px; padding-left: 28px;">
                      <label class="abaq-label" for="p1-whatsapp">
                        Número con cuenta de WhatsApp <span class="text-required">*</span>
                      </label>
                      <input
                        id="p1-whatsapp"
                        name="whatsappNumber"
                        type="tel"
                        maxlength="14"
                        class="abaq-input"
                        [class.input-invalid]="invalidFields['whatsappNumber']"
                        [ngModel]="p1.whatsappNumber"
                        (ngModelChange)="onPhoneChange('whatsappNumber', $event)"
                        placeholder="442 000 0000"
                      />
                      <span style="font-size: 11.5px; color: #64748b; margin-top: 4px; display: block;">
                        Ingresa el número que tienes vinculado a WhatsApp para comunicaciones de brigadas.
                      </span>
                      @if (invalidFields['whatsappNumber']) {
                        <span class="field-error-text">⚠️ {{ invalidFields['whatsappNumber'] }}</span>
                      }
                    </div>
                  }
                </div>

                <div style="height: 1px; background: #e2e8f0;"></div>

                <!-- Casilla 2: Segundo número de contacto -->
                <div>
                  <label style="display: flex; align-items: center; gap: 10px; cursor: pointer; user-select: none;">
                    <input
                      type="checkbox"
                      name="hasSecondaryContact"
                      [(ngModel)]="p1.hasSecondaryContact"
                      (ngModelChange)="onFieldChange('hasSecondaryContact', 'personal')"
                      style="width: 18px; height: 18px; accent-color: #24366f; cursor: pointer;"
                    />
                    <span style="font-size: 13.5px; font-weight: 700; color: #24366f;">
                      ¿Deseas registrar un segundo número telefónico de contacto o emergencia?
                    </span>
                  </label>

                  @if (p1.hasSecondaryContact) {
                    <div style="margin-top: 12px; padding-left: 28px;">
                      <label class="abaq-label" for="p1-secondaryPhone">
                        Segundo número de contacto (10 dígitos) <span class="text-required">*</span>
                      </label>
                      <input
                        id="p1-secondaryPhone"
                        name="secondaryPhone"
                        type="tel"
                        maxlength="14"
                        class="abaq-input"
                        [class.input-invalid]="invalidFields['secondaryPhone']"
                        [ngModel]="p1.secondaryPhone"
                        (ngModelChange)="onPhoneChange('secondaryPhone', $event)"
                        placeholder="442 000 0000"
                      />
                      <span style="font-size: 11.5px; color: #64748b; margin-top: 4px; display: block;">
                        Número alternativo de contacto directo o familiar en Querétaro.
                      </span>
                      @if (invalidFields['secondaryPhone']) {
                        <span class="field-error-text">⚠️ {{ invalidFields['secondaryPhone'] }}</span>
                      }
                    </div>
                  }
                </div>
              </div>

              <!-- Solo Servicio Social: CURP y Matrícula -->
              @if (p1.userType === 'SS') {
                <div class="onboarding-fields-grid-2">
                  <div>
                    <label class="abaq-label" for="p1-curp">
                      CURP (Clave Única de Registro de Población) <span class="text-required">*</span>
                    </label>
                    <input
                      id="p1-curp"
                      name="curp"
                      type="text"
                      maxlength="18"
                      class="abaq-input"
                      style="text-transform: uppercase;"
                      [class.input-invalid]="invalidFields['curp']"
                      [(ngModel)]="p1.curp"
                      (ngModelChange)="onFieldChange('curp', 'personal')"
                      placeholder="MOVC020514HQRMRA09"
                    />
                    <span style="font-size: 11.5px; color: #64748b; margin-top: 4px; display: block;">
                      18 caracteres alfanuméricos oficiales (RENAPO).
                    </span>
                    @if (invalidFields['curp']) {
                      <span class="field-error-text">⚠️ {{ invalidFields['curp'] }}</span>
                    }
                  </div>

                  <div>
                    <label class="abaq-label" for="p1-studentId">
                      Matrícula o ID Estudiantil <span class="text-required">*</span>
                    </label>
                    <input
                      id="p1-studentId"
                      name="studentId"
                      type="text"
                      class="abaq-input"
                      [class.input-invalid]="invalidFields['studentId']"
                      [(ngModel)]="p1.studentId"
                      (ngModelChange)="onFieldChange('studentId', 'personal')"
                      placeholder="Ej. 2024-UAQ-8842"
                    />
                    <span style="font-size: 11.5px; color: #64748b; margin-top: 4px; display: block;">
                      Clave de estudiante oficial en tu universidad.
                    </span>
                    @if (invalidFields['studentId']) {
                      <span class="field-error-text">⚠️ {{ invalidFields['studentId'] }}</span>
                    }
                  </div>
                </div>
              }
            </fieldset>

            <!-- Sección 3: Datos Académicos (SS) vs Formación Modular (VG) -->
            <fieldset id="sec-academic" class="onboarding-fieldset">
              <legend class="onboarding-fieldset-legend" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                <span>{{ p1.userType === 'SS' ? '03 Datos académicos' : '03 Formación y Nivel de Estudios' }}</span>
                <span
                  class="section-saved-indicator"
                  [class.status-saving]="getSectionStatus('academic') === 'saving'"
                  [class.status-saved]="getSectionStatus('academic') === 'saved'"
                  [class.status-error]="getSectionStatus('academic') === 'error'"
                  [title]="getSectionStatusTitle('academic')"
                >
                  <span class="material-symbols-outlined">{{ getSectionIcon('academic') }}</span>
                  <span>{{ getSectionLabel('academic') }}</span>
                </span>
              </legend>

              @if (p1.userType === 'SS') {
                <div class="onboarding-fields-grid-2">
                  <div>
                    <label class="abaq-label" for="academic-level">
                      Nivel de estudios
                    </label>
                    <app-custom-select
                      id="academic-level"
                      name="academicLevel"
                      [options]="academicLevels"
                      [(ngModel)]="p1.academicLevel"
                      (ngModelChange)="onFieldChange('academicLevel', 'academic')"
                      placeholder="Selecciona nivel"
                    ></app-custom-select>
                  </div>

                  <div>
                    <label class="abaq-label" for="p1-university">
                      Institución académica (Querétaro) <span class="text-required">*</span>
                    </label>
                    <app-custom-select
                      id="p1-university"
                      name="university"
                      [options]="universities"
                      [allowCustomValue]="true"
                      [invalid]="!!invalidFields['university']"
                      [(ngModel)]="p1.university"
                      (ngModelChange)="onFieldChange('university', 'academic')"
                      placeholder="Ej. Universidad Autónoma de Querétaro (UAQ)"
                    ></app-custom-select>
                    @if (invalidFields['university']) {
                      <span class="field-error-text">⚠️ {{ invalidFields['university'] }}</span>
                    }
                  </div>
                </div>

                <!-- Carrera -->
                <div style="margin-top: 14px;">
                  <label class="abaq-label" for="p1-carrera">
                    Carrera <span class="text-required">*</span>
                  </label>
                  <app-custom-select
                    id="p1-carrera"
                    name="carrera"
                    [options]="careers"
                    [allowCustomValue]="true"
                    [invalid]="!!invalidFields['carrera']"
                    [(ngModel)]="p1.carrera"
                    (ngModelChange)="onFieldChange('carrera', 'academic')"
                    placeholder="Ej. Licenciatura en Psicología"
                  ></app-custom-select>
                  @if (invalidFields['carrera']) {
                    <span class="field-error-text">⚠️ {{ invalidFields['carrera'] }}</span>
                  }
                </div>

                <!-- Esquema de periodos y avance académico (Aprovecha todo el ancho del contenedor) -->
                <div style="margin-top: 16px;">
                  <label class="abaq-label" for="p1-period-number">
                    Esquema de periodos y avance académico <span class="text-required">*</span>
                  </label>
                  <div class="onboarding-period-composite-grid">
                    <!-- 1. Tipo de periodo académico (Semestral, Cuatrimestral, etc.) -->
                    <div>
                      <app-custom-select
                        id="p1-periodType"
                        name="periodType"
                        [options]="periodTypes"
                        [(ngModel)]="p1.periodType"
                        (ngModelChange)="onPeriodTypeChange($event)"
                        placeholder="Tipo de periodo"
                      ></app-custom-select>
                      <span style="font-size: 11px; color: #64748b; margin-top: 4px; display: block;">
                        Modalidad del plan de estudios
                      </span>
                    </div>

                    <!-- 2. Oración a completar: [ Número editable ] [ Campo bloqueado en gris con regla gramatical + periodo ] -->
                    <div>
                      <div class="period-sentence-row">
                        <!-- Bloque libre/editable del número de periodo -->
                        <div style="position: relative; flex-shrink: 0;">
                          <input
                            id="p1-period-number"
                            name="periodNumber"
                            type="text"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            maxlength="2"
                            class="abaq-input period-number-input"
                            [class.input-invalid]="invalidFields['semester']"
                            [ngModel]="p1.periodNumber"
                            (ngModelChange)="onPeriodNumberChange($event)"
                            placeholder="Ej. 4"
                            title="Escribe el número de periodo en el que vas (ej. 1, 2, 3, 4, 5...)"
                          />
                        </div>

                        <!-- Campo bloqueado en gris con la regla gramatical y nombre del periodo -->
                        <div
                          class="abaq-input period-locked-field"
                          title="Regla gramatical y periodo actualizados automáticamente según el tipo de periodo y número ingresado"
                        >
                          <span style="color: #64748b; font-weight: 600; font-size: 13px;">·</span>
                          <span>{{ getLockedPeriodLabel() }}</span>
                        </div>
                      </div>

                      <!-- Ayuda y confirmación del periodo registrado -->
                      <div style="margin-top: 5px;">
                        <span style="font-size: 11.5px; color: #64748b;">
                          {{ p1.semester ? 'Registrado como: ' + p1.semester : 'Escribe tu número de periodo en curso (ej. 4)' }}
                        </span>
                      </div>

                      @if (invalidFields['semester']) {
                        <span class="field-error-text">⚠️ {{ invalidFields['semester'] }}</span>
                      }
                    </div>
                  </div>
                </div>

                <!-- Fechas de inicio y conclusión del servicio social en ABAQ (Cuadrícula dedicada de 2 columnas) -->
                <div class="onboarding-fields-grid-2" style="margin-top: 16px;">
                  <div>
                    <label class="abaq-label" for="p1-service-start">
                      Fecha de inicio del servicio social
                    </label>
                    <app-custom-datepicker
                      id="p1-service-start"
                      name="serviceStartDate"
                      [(ngModel)]="p1.serviceStartDate"
                      (ngModelChange)="onFieldChange('serviceStartDate', 'academic')"
                      placeholder="DD/MM/AAAA"
                    ></app-custom-datepicker>
                    <span style="font-size: 11.5px; color: #64748b; margin-top: 4px; display: block; line-height: 1.4;">
                      Fecha en que vas a empezar tu servicio social en ABAQ (no el inicio de tu carrera universitaria).
                    </span>
                  </div>

                  <div>
                    <label class="abaq-label" for="p1-service-end">
                      Fecha de conclusión del servicio social
                    </label>
                    <app-custom-datepicker
                      id="p1-service-end"
                      name="serviceEndDate"
                      [(ngModel)]="p1.serviceEndDate"
                      (ngModelChange)="onFieldChange('serviceEndDate', 'academic')"
                      placeholder="DD/MM/AAAA"
                    ></app-custom-datepicker>
                    <span style="font-size: 11.5px; color: #64748b; margin-top: 4px; display: block; line-height: 1.4;">
                      Fecha en que debes acabar y acreditar tus horas de servicio social en ABAQ (no el fin de tu carrera).
                    </span>
                  </div>
                </div>
              } @else {
                <!-- Formación Modular para Voluntario General (Fiel al React Mockup) -->
                <div style="display: flex; flex-direction: column; gap: 16px;">
                  <p style="font-size: 13.5px; color: #64748b; margin: 0;">
                    Comparte tu trayectoria educativa. Puedes registrar tus estudios de preparatoria, universidad, maestrías o doctorados.
                  </p>

                  @for (deg of p1.degrees; track $index; let idx = $index) {
                    <div
                      style="padding: 16px; border-radius: 12px; border: 1px solid #e2e8f0; background: #f8fafc; position: relative;"
                    >
                      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                        <strong style="font-size: 14px; color: #1e3a8a;">
                          Estudio #{{ idx + 1 }}
                        </strong>
                        @if (p1.degrees.length > 1) {
                          <button
                            type="button"
                            (click)="removeDegree(idx)"
                            style="background: none; border: none; color: #dc2626; font-size: 12.5px; font-weight: 700; cursor: pointer;"
                          >
                            Eliminar
                          </button>
                        }
                      </div>

                      <div class="onboarding-fields-grid-2">
                        <div>
                          <label class="abaq-label">Nivel de estudios</label>
                          <app-custom-select
                            [options]="degreeLevels"
                            [(ngModel)]="deg.level"
                            [name]="'degLevel_' + idx"
                            (ngModelChange)="onFieldChange('degree', 'academic')"
                            placeholder="Nivel de estudios"
                          ></app-custom-select>
                        </div>

                        <div>
                          <label class="abaq-label">Institución educativa <span class="text-required">*</span></label>
                          <input
                            [id]="'deg-inst-' + idx"
                            type="text"
                            class="abaq-input"
                            [class.input-invalid]="invalidFields['degreeInst_' + idx]"
                            [(ngModel)]="deg.institution"
                            (ngModelChange)="onFieldChange('degreeInst_' + idx, 'academic')"
                            [name]="'degInst_' + idx"
                            placeholder="Ej. UAQ, ITQ, UNAM, Tec de Monterrey..."
                          />
                          @if (invalidFields['degreeInst_' + idx]) {
                            <span class="field-error-text">⚠️ {{ invalidFields['degreeInst_' + idx] }}</span>
                          }
                        </div>
                      </div>

                      <div class="onboarding-fields-grid-2" style="margin-top: 12px;">
                        <div>
                          <label class="abaq-label">Carrera, programa o especialidad <span class="text-required">*</span></label>
                          <input
                            [id]="'deg-title-' + idx"
                            type="text"
                            class="abaq-input"
                            [class.input-invalid]="invalidFields['degreeTitle_' + idx]"
                            [(ngModel)]="deg.title"
                            (ngModelChange)="onFieldChange('degreeTitle_' + idx, 'academic')"
                            [name]="'degTitle_' + idx"
                            placeholder="Ej. Licenciatura en Administración, Maestría en Ciencias..."
                          />
                          @if (invalidFields['degreeTitle_' + idx]) {
                            <span class="field-error-text">⚠️ {{ invalidFields['degreeTitle_' + idx] }}</span>
                          }
                        </div>

                        <div>
                          <label class="abaq-label">Estado de los estudios</label>
                          <app-custom-select
                            [options]="degreeStatuses"
                            [(ngModel)]="deg.status"
                            [name]="'degStatus_' + idx"
                            (ngModelChange)="onFieldChange('degree', 'academic')"
                            placeholder="Estado de los estudios"
                          ></app-custom-select>
                        </div>
                      </div>
                    </div>
                  }

                  <button
                    type="button"
                    (click)="addDegree()"
                    style="display: inline-flex; align-items: center; gap: 6px; align-self: flex-start; padding: 8px 14px; border-radius: 8px; border: 1.5px dashed #1e3a8a; background: rgba(30, 58, 138, 0.05); color: #1e3a8a; font-size: 13px; font-weight: 700; cursor: pointer;"
                  >
                    <span class="material-symbols-outlined" style="font-size: 18px;">add_circle</span>
                    <span>+ Agregar otra universidad, maestría o doctorado</span>
                  </button>

                  <div style="margin-top: 8px;">
                    <label class="abaq-label" for="p1-occupation">
                      Ocupación o actividad actual
                    </label>
                    <input
                      id="p1-occupation"
                      name="occupation"
                      type="text"
                      class="abaq-input"
                      [(ngModel)]="p1.occupation"
                      (ngModelChange)="onFieldChange('occupation', 'academic')"
                      placeholder="Ej. Profesionista independiente, Diseñador, Veterinario..."
                    />
                  </div>
                </div>
              }
            </fieldset>

            <!-- Sección 4: Presencia en Redes Sociales (Opcional - ambos roles) -->
            <fieldset id="sec-socials" class="onboarding-fieldset">
              <legend class="onboarding-fieldset-legend" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                <span>04 Presencia en redes sociales (Opcional)</span>
                <span
                  class="section-saved-indicator"
                  [class.status-saving]="getSectionStatus('social') === 'saving'"
                  [class.status-saved]="getSectionStatus('social') === 'saved'"
                  [class.status-error]="getSectionStatus('social') === 'error'"
                  [title]="getSectionStatusTitle('social')"
                >
                  <span class="material-symbols-outlined">{{ getSectionIcon('social') }}</span>
                  <span>{{ getSectionLabel('social') }}</span>
                </span>
              </legend>

              <p style="font-size: 13.5px; color: #64748b; margin-top: 0; margin-bottom: 16px; line-height: 1.5;">
                Indica los nombres de usuario o perfiles de las redes sociales que utilices. Puedes registrar solo aquellas en las que tengas cuenta activa.
              </p>

              <div class="onboarding-fields-grid-2">
                <!-- Facebook -->
                <div class="social-media-field-wrap">
                  <label class="abaq-label" for="p1-social-facebook">
                    Facebook
                  </label>
                  <div class="social-input-prefix-box">
                    <span class="social-icon-badge" title="Facebook">
                      <svg class="lucide lucide-facebook" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                      </svg>
                    </span>
                    <input
                      id="p1-social-facebook"
                      name="socialFacebook"
                      type="text"
                      class="social-input-core"
                      [(ngModel)]="p1.socialMedia.facebook"
                      (ngModelChange)="onFieldChange('facebook', 'social')"
                      placeholder="facebook.com/tu_perfil o usuario"
                    />
                  </div>
                </div>

                <!-- Instagram -->
                <div class="social-media-field-wrap">
                  <label class="abaq-label" for="p1-social-instagram">
                    Instagram
                  </label>
                  <div class="social-input-prefix-box">
                    <span class="social-icon-badge" title="Instagram">
                      <svg class="lucide lucide-instagram" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                        <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
                      </svg>
                    </span>
                    <input
                      id="p1-social-instagram"
                      name="socialInstagram"
                      type="text"
                      class="social-input-core"
                      [(ngModel)]="p1.socialMedia.instagram"
                      (ngModelChange)="onFieldChange('instagram', 'social')"
                      placeholder="@tu_usuario"
                    />
                  </div>
                </div>

                <!-- TikTok -->
                <div class="social-media-field-wrap">
                  <label class="abaq-label" for="p1-social-tiktok">
                    TikTok
                  </label>
                  <div class="social-input-prefix-box">
                    <span class="social-icon-badge" title="TikTok">
                      <svg class="lucide lucide-tiktok" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"/>
                      </svg>
                    </span>
                    <input
                      id="p1-social-tiktok"
                      name="socialTiktok"
                      type="text"
                      class="social-input-core"
                      [(ngModel)]="p1.socialMedia.tiktok"
                      (ngModelChange)="onFieldChange('tiktok', 'social')"
                      placeholder="@tu_usuario"
                    />
                  </div>
                </div>

                <!-- X (Twitter) -->
                <div class="social-media-field-wrap">
                  <label class="abaq-label" for="p1-social-x">
                    X (Twitter)
                  </label>
                  <div class="social-input-prefix-box">
                    <span class="social-icon-badge" title="X (Twitter)">
                      <svg class="lucide lucide-twitter" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M4 4l11.733 16h4.267l-11.733 -16z"/>
                        <path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772"/>
                      </svg>
                    </span>
                    <input
                      id="p1-social-x"
                      name="socialX"
                      type="text"
                      class="social-input-core"
                      [(ngModel)]="p1.socialMedia.x"
                      (ngModelChange)="onFieldChange('x', 'social')"
                      placeholder="@tu_usuario"
                    />
                  </div>
                </div>

                <!-- YouTube -->
                <div class="social-media-field-wrap">
                  <label class="abaq-label" for="p1-social-youtube">
                    YouTube
                  </label>
                  <div class="social-input-prefix-box">
                    <span class="social-icon-badge" title="YouTube">
                      <svg class="lucide lucide-youtube" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"/>
                        <polygon points="10 15 15 12 10 9 10 15"/>
                      </svg>
                    </span>
                    <input
                      id="p1-social-youtube"
                      name="socialYoutube"
                      type="text"
                      class="social-input-core"
                      [(ngModel)]="p1.socialMedia.youtube"
                      (ngModelChange)="onFieldChange('youtube', 'social')"
                      placeholder="@canal o nombre"
                    />
                  </div>
                </div>

                <!-- LinkedIn -->
                <div class="social-media-field-wrap">
                  <label class="abaq-label" for="p1-social-linkedin">
                    LinkedIn
                  </label>
                  <div class="social-input-prefix-box">
                    <span class="social-icon-badge" title="LinkedIn">
                      <svg class="lucide lucide-linkedin" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                        <rect width="4" height="12" x="2" y="9"/>
                        <circle cx="4" cy="4" r="2"/>
                      </svg>
                    </span>
                    <input
                      id="p1-social-linkedin"
                      name="socialLinkedin"
                      type="text"
                      class="social-input-core"
                      [(ngModel)]="p1.socialMedia.linkedin"
                      (ngModelChange)="onFieldChange('linkedin', 'social')"
                      placeholder="linkedin.com/in/tu_perfil"
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          }

          <!-- =========================================================
               FASE 2: MÓDULOS DE INDUCCIÓN (10 HORAS)
               ========================================================= -->
          @if (currentPhase === 2) {
            <div class="onboarding-card-header">
              <div style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 6px;">
                <h1 class="onboarding-card-title" style="margin-bottom: 0;">Módulos de Inducción ABAQ</h1>
              </div>
              <p class="onboarding-card-subtitle">
                Revisa cada uno de los 6 temas formativos de bienestar animal y completa tus 3 reflexiones de aprendizaje.
              </p>
            </div>

            <!-- NOTA DE INDUCCIÓN FORMATIVA -->
            @if (p1.userType === 'SS') {
              <div
                style="margin-bottom: 20px; padding: 13px 18px; border-radius: 12px; background: #eff6ff; border: 1.5px solid #bfdbfe; color: #1e40af; display: flex; align-items: flex-start; gap: 12px;"
                role="note"
              >
                <span class="material-symbols-outlined" style="font-size: 22px; color: #2563eb; flex-shrink: 0; margin-top: 1px;">school</span>
                <div>
                  <h4 style="margin: 0 0 3px; font-size: 13.5px; font-weight: 800; color: #1e3a8a; text-transform: uppercase; letter-spacing: 0.3px;">
                    Inducción Institucional
                  </h4>
                  <p style="margin: 0; font-size: 13px; line-height: 1.5; color: #1e40af;">
                    Revisa los materiales formativos de cada módulo y responde las 3 preguntas de reflexión para avanzar a la siguiente fase de tu registro.
                  </p>
                </div>
              </div>
            }

            <!-- ADVERTENCIA Y DECLARACIÓN BAJO PROTESTA -->
            <div
              style="margin-bottom: 22px; padding: 16px 20px; border-radius: 14px; background: #fffbeb; border: 1.5px solid #fde68a; color: #92400e;"
              role="alert"
            >
              <div style="display: flex; align-items: flex-start; gap: 12px;">
                <span class="material-symbols-outlined" style="font-size: 24px; color: #d97706; flex-shrink: 0; margin-top: 1px;">gavel</span>
                <div>
                  <h4 style="margin: 0 0 6px; font-size: 14px; font-weight: 800; color: #78350f; text-transform: uppercase; letter-spacing: 0.3px;">
                    ⚠️ DECLARACIÓN BAJO PROTESTA DE COMPRENSIÓN Y REVISIÓN ÍNTEGRA
                  </h4>
                  <p style="margin: 0; font-size: 13px; line-height: 1.55; color: #92400e;">
                    Marcar cada casilla certifica formalmente haber revisado de inicio a fin y asimilado en su totalidad el contenido del módulo.
                    <strong>La evaluación se realiza con base en el texto escrito de tus reflexiones; respuestas vagas, genéricas o redactadas con IA provocarán la cancelación inmediata de tu registro</strong>, debiendo registrarte nuevamente para rehacer el formulario desde el inicio.
                  </p>
                </div>
              </div>
            </div>

            <fieldset id="sec-ind-modules" class="onboarding-fieldset">
              <legend class="onboarding-fieldset-legend" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                <span>01 · Módulos Formativos y Material Multimedia</span>
                <span
                  class="section-saved-indicator"
                  [class.status-saving]="getSectionStatus('induction') === 'saving'"
                  [class.status-saved]="getSectionStatus('induction') === 'saved'"
                  [class.status-error]="getSectionStatus('induction') === 'error'"
                  [title]="getSectionStatusTitle('induction')"
                >
                  <span class="material-symbols-outlined">{{ getSectionIcon('induction') }}</span>
                  <span>{{ getSectionLabel('induction') }}</span>
                </span>
              </legend>

              <div style="display: flex; flex-direction: column; gap: 20px;">
                @for (mod of inductionModulesList; track mod.id) {
                  <div
                    [id]="mod.targetId"
                    style="border-radius: 16px; border: 1.5px solid #e2e8f0; background: #ffffff; padding: 20px 22px; transition: all 0.2s; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);"
                  >
                    <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; flex-wrap: wrap;">
                      <div style="flex: 1; min-width: 240px;">
                        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
                          @if (mod.badge) {
                            <span style="font-size: 11px; font-weight: 800; background: #e0f2fe; color: #0369a1; padding: 2px 8px; border-radius: 999px;">
                              {{ mod.badge }}
                            </span>
                          }
                          <span style="font-size: 12px; font-weight: 700; color: #64748b;">Módulo {{ mod.number }}</span>
                        </div>
                        <h3 style="font-size: 16px; font-weight: 800; color: #1e3a8a; margin: 0 0 6px;">
                          {{ mod.title }}
                        </h3>
                        @if (mod.description) {
                          <p style="font-size: 13px; color: #475569; margin: 0 0 10px; line-height: 1.5;">
                            {{ mod.description }}
                          </p>
                        }
                      </div>

                      <div style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap;">
                        @if (mod.mediaUrl) {
                          <a
                            [href]="mod.mediaUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                            style="display: inline-flex; align-items: center; gap: 5px; padding: 7px 14px; border-radius: 8px; background: #f1f5f9; color: #1e3a8a; font-size: 12.5px; font-weight: 700; text-decoration: none; border: 1px solid #cbd5e1;"
                          >
                            <span class="material-symbols-outlined" style="font-size: 17px;">open_in_new</span>
                            <span>{{ mod.actionText || 'Ver material ↗' }}</span>
                          </a>
                        }

                        <label style="display: inline-flex; align-items: center; gap: 8px; cursor: pointer; padding: 7px 14px; border-radius: 999px; background: #f8fafc; border: 1.5px solid #cbd5e1; transition: all 0.2s;">
                          <input
                            type="checkbox"
                            [id]="'check-mod-' + mod.id"
                            [checked]="isModuleCompleted(mod.id)"
                            (change)="toggleModule(mod.id)"
                            style="width: 17px; height: 17px; accent-color: #24366f; cursor: pointer;"
                          />
                          <span style="font-size: 12px; font-weight: 700;" [style.color]="isModuleCompleted(mod.id) ? '#16a34a' : '#475569'">
                            {{ isModuleCompleted(mod.id) ? '✓ He visto y comprendido este módulo' : 'Certifico haber visto y comprendido este módulo' }}
                          </span>
                        </label>
                      </div>
                    </div>

                    <!-- Módulo 1: Redes Oficiales y Checkbox Social -->
                    @if (mod.id === 1 && mod.socialChannels) {
                      <div style="margin-top: 14px; padding-top: 12px; border-top: 1px dashed #cbd5e1;">
                        <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); gap: 8px; margin-bottom: 12px;">
                          @for (ch of mod.socialChannels; track ch.id) {
                            <a
                              [href]="ch.url"
                              target="_blank"
                              rel="noopener noreferrer"
                              style="display: flex; align-items: center; justify-content: space-between; padding: 7px 10px; border-radius: 8px; background: #f8fafc; border: 1px solid #e2e8f0; font-size: 12px; color: #1e293b; text-decoration: none;"
                            >
                              <span style="font-weight: 600; display: inline-flex; align-items: center; gap: 6px;">
                                @switch (ch.id) {
                                  @case ('facebook') {
                                    <svg class="lucide lucide-facebook" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                                    </svg>
                                  }
                                  @case ('instagram') {
                                    <svg class="lucide lucide-instagram" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                      <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
                                      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                                      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
                                    </svg>
                                  }
                                  @case ('tiktok') {
                                    <svg class="lucide lucide-tiktok" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"/>
                                    </svg>
                                  }
                                  @case ('twitter') {
                                    <svg class="lucide lucide-twitter" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M4 4l11.733 16h4.267l-11.733 -16z"/>
                                      <path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772"/>
                                    </svg>
                                  }
                                  @case ('linkedin') {
                                    <svg class="lucide lucide-linkedin" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                                      <rect width="4" height="12" x="2" y="9"/>
                                      <circle cx="4" cy="4" r="2"/>
                                    </svg>
                                  }
                                  @default {
                                    <svg class="lucide lucide-globe" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                      <circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/>
                                    </svg>
                                  }
                                }
                                <span>{{ ch.name }}</span>
                              </span>
                              <span style="font-size: 11px; color: #2563eb;">{{ ch.actionText }}</span>
                            </a>
                          }
                        </div>

                        <label style="display: flex; align-items: center; gap: 8px; cursor: pointer; font-size: 13px; font-weight: 700; color: #1e3a8a;">
                          <input
                            id="p2-socials-check"
                            type="checkbox"
                            name="socialsFollowed"
                            [(ngModel)]="p2.socialsFollowed"
                            (ngModelChange)="onFieldChange('socialsFollowed', 'induction')"
                            style="width: 17px; height: 17px; accent-color: #5ca83a;"
                          />
                          <span>{{ mod.confirmationCheckboxText }}</span>
                        </label>
                        @if (invalidFields['socialsFollowed']) {
                          <span class="field-error-text">⚠️ {{ invalidFields['socialsFollowed'] }}</span>
                        }
                      </div>
                    }

                    <!-- 3 FILAS DE COMENTARIOS / REFLEXIONES POR MÓDULO (1 POR FILA) -->
                    <div style="margin-top: 18px; padding-top: 16px; border-top: 1px solid #f1f5f9; display: flex; flex-direction: column; gap: 14px;">
                      <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 6px;">
                        <div style="font-size: 12.5px; font-weight: 800; color: #24366f; text-transform: uppercase; letter-spacing: 0.5px;">
                          Tus reflexiones de aprendizaje (Módulo {{ mod.number }}):
                        </div>
                        <span style="font-size: 11.5px; color: #64748b;">
                          * Respuestas reflexivas, propias y completas
                        </span>
                      </div>

                      <!-- Fila 1: ¿Qué me gustó? -->
                      <div>
                        <label class="abaq-label" [for]="'liked_' + mod.id" style="font-size: 12.5px; margin-bottom: 5px;">
                          1. ¿Qué me gustó? <span class="text-required">*</span>
                        </label>
                        <textarea
                          [id]="'liked_' + mod.id"
                          rows="2"
                          class="abaq-input"
                          style="height: auto; padding: 10px 12px; font-size: 13px;"
                          [(ngModel)]="p2.reflections['modulo-' + mod.id].liked"
                          [name]="'liked_' + mod.id"
                          (ngModelChange)="onFieldChange('reflections_' + mod.id, 'induction')"
                          [placeholder]="getQuestionPlaceholder(mod.id, 'liked')"
                        ></textarea>
                      </div>

                      <!-- Fila 2: ¿Qué considero lo más importante? -->
                      <div>
                        <label class="abaq-label" [for]="'important_' + mod.id" style="font-size: 12.5px; margin-bottom: 5px;">
                          2. ¿Qué considero lo más importante? <span class="text-required">*</span>
                        </label>
                        <textarea
                          [id]="'important_' + mod.id"
                          rows="2"
                          class="abaq-input"
                          style="height: auto; padding: 10px 12px; font-size: 13px;"
                          [(ngModel)]="p2.reflections['modulo-' + mod.id].important"
                          [name]="'important_' + mod.id"
                          (ngModelChange)="onFieldChange('reflections_' + mod.id, 'induction')"
                          [placeholder]="getQuestionPlaceholder(mod.id, 'important')"
                        ></textarea>
                      </div>

                      <!-- Fila 3: ¿Qué puede mejorar? -->
                      <div>
                        <label class="abaq-label" [for]="'improve_' + mod.id" style="font-size: 12.5px; margin-bottom: 5px;">
                          3. ¿Qué puede mejorar? <span class="text-required">*</span>
                        </label>
                        <textarea
                          [id]="'improve_' + mod.id"
                          rows="2"
                          class="abaq-input"
                          style="height: auto; padding: 10px 12px; font-size: 13px;"
                          [(ngModel)]="p2.reflections['modulo-' + mod.id].improve"
                          [name]="'improve_' + mod.id"
                          (ngModelChange)="onFieldChange('reflections_' + mod.id, 'induction')"
                          [placeholder]="getQuestionPlaceholder(mod.id, 'improve')"
                        ></textarea>
                      </div>

                      @if (invalidFields['reflections_' + mod.id]) {
                        <span class="field-error-text" style="margin-top: 4px;">
                          ⚠️ {{ invalidFields['reflections_' + mod.id] }}
                        </span>
                      }
                    </div>
                  </div>
                }
              </div>

              @if (invalidFields['modules']) {
                <span class="field-error-text" style="margin-top: 14px; display: block; font-size: 13px;">
                  ⚠️ {{ invalidFields['modules'] }}
                </span>
              }
            </fieldset>
          }

          <!-- =========================================================
               FASE 3: SOBRE MÍ (TALENTOS, MOTIVACIÓN Y ACTIVIDADES)
               ========================================================= -->
          @if (currentPhase === 3) {
            <div class="onboarding-card-header">
              <h1 class="onboarding-card-title">Sobre mí y áreas de afinidad</h1>
              <p class="onboarding-card-subtitle">
                Queremos conocer tus talentos y motivaciones para integrarte a las actividades que mejor se adapten a tu perfil.
              </p>
            </div>

            <fieldset id="sec-about-bio" class="onboarding-fieldset">
              <legend class="onboarding-fieldset-legend" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                <span>01 · Semblanza y Habilidades</span>
                <span
                  class="section-saved-indicator"
                  [class.status-saving]="getSectionStatus('survey_bio') === 'saving'"
                  [class.status-saved]="getSectionStatus('survey_bio') === 'saved'"
                  [class.status-error]="getSectionStatus('survey_bio') === 'error'"
                  [title]="getSectionStatusTitle('survey_bio')"
                >
                  <span class="material-symbols-outlined">{{ getSectionIcon('survey_bio') }}</span>
                  <span>{{ getSectionLabel('survey_bio') }}</span>
                </span>
              </legend>

              <div style="display: grid; gap: 14px;">
                <div>
                  <label class="abaq-label" for="p3-bio">
                    Semblanza personal / Biografía <span class="text-required">*</span>
                  </label>
                  <textarea
                    id="p3-bio"
                    name="bioPersonal"
                    rows="3"
                    class="abaq-input"
                    style="height: auto; padding: 12px;"
                    [class.input-invalid]="invalidFields['bioPersonal']"
                    [(ngModel)]="p3.bioPersonal"
                    (ngModelChange)="onFieldChange('bioPersonal', 'survey_bio')"
                    placeholder="Cuéntanos brevemente sobre ti y tu compromiso con el bienestar animal..."
                  ></textarea>
                  @if (invalidFields['bioPersonal']) {
                    <span class="field-error-text">⚠️ {{ invalidFields['bioPersonal'] }}</span>
                  }
                </div>

                <!-- Áreas de interés con Chips de sugerencia rápida -->
                <div>
                  <label class="abaq-label" for="p3-intereses">
                    Áreas de interés principal en ABAQ <span class="text-required">*</span>
                  </label>
                  <input
                    id="p3-intereses"
                    name="intereses"
                    type="text"
                    class="abaq-input"
                    [class.input-invalid]="invalidFields['intereses']"
                    [(ngModel)]="p3.intereses"
                    (ngModelChange)="onFieldChange('intereses', 'survey_bio')"
                    placeholder="Ej. Jornadas de esterilización, rescate animal, ferias de adopción..."
                  />
                  <div style="margin-top: 8px;">
                    <span style="font-size: 11.5px; font-weight: 700; color: #64748b; margin-right: 6px;">
                      Sugerencias rápidas (haz clic para agregar):
                    </span>
                    <div style="display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px;">
                      @for (tag of quickTags; track tag) {
                        <button
                          type="button"
                          (click)="addInterestTag(tag)"
                          style="background: #f1f5f9; border: 1px solid #cbd5e1; border-radius: 999px; padding: 3px 10px; font-size: 11.5px; color: #1e3a8a; font-weight: 600; cursor: pointer;"
                        >
                          + {{ tag }}
                        </button>
                      }
                    </div>
                  </div>
                  @if (invalidFields['intereses']) {
                    <span class="field-error-text">⚠️ {{ invalidFields['intereses'] }}</span>
                  }
                </div>

                <div id="sec-about-talents" class="onboarding-fields-grid-2">
                  <div>
                    <label class="abaq-label" for="p3-talentos">
                      Principales talentos y habilidades <span class="text-required">*</span>
                    </label>
                    <input
                      id="p3-talentos"
                      name="talentos"
                      type="text"
                      class="abaq-input"
                      [class.input-invalid]="invalidFields['talentos']"
                      [(ngModel)]="p3.talentos"
                      (ngModelChange)="onFieldChange('talentos', 'survey_bio')"
                      placeholder="Ej. Primeros auxilios, redacción, fotografía, logística..."
                    />
                    @if (invalidFields['talentos']) {
                      <span class="field-error-text">⚠️ {{ invalidFields['talentos'] }}</span>
                    }
                  </div>

                  <div>
                    <label class="abaq-label" for="p3-animalExp">
                      Experiencia previa con animales de compañía
                    </label>
                    <app-custom-select
                      id="p3-animalExp"
                      name="animalExperience"
                      [options]="animalExperienceOptions"
                      [(ngModel)]="p3.animalExperience"
                      (ngModelChange)="onFieldChange('animalExperience', 'survey_bio')"
                      placeholder="Experiencia con animales"
                    ></app-custom-select>
                  </div>
                </div>

                <div>
                  <label class="abaq-label" for="p3-aportes">
                    Talentos y conocimientos que deseas compartir con ABAQ <span class="text-required">*</span>
                  </label>
                  <textarea
                    id="p3-aportes"
                    name="aportesAbaq"
                    rows="2"
                    class="abaq-input"
                    style="height: auto; padding: 10px;"
                    [class.input-invalid]="invalidFields['aportesAbaq']"
                    [(ngModel)]="p3.aportesAbaq"
                    (ngModelChange)="onFieldChange('aportesAbaq', 'survey_bio')"
                    placeholder="Apoyo activo en campañas, ferias de adopción, difusión, diseño..."
                  ></textarea>
                  @if (invalidFields['aportesAbaq']) {
                    <span class="field-error-text">⚠️ {{ invalidFields['aportesAbaq'] }}</span>
                  }
                </div>

                <div id="sec-about-motivation" class="onboarding-fields-grid-2">
                  <div>
                    <label class="abaq-label" for="p3-descExp">
                      Detalles de tu experiencia con animales / rescates
                    </label>
                    <textarea
                      id="p3-descExp"
                      name="descExperiencia"
                      rows="2"
                      class="abaq-input"
                      style="height: auto; padding: 10px;"
                      [(ngModel)]="p3.descExperiencia"
                      (ngModelChange)="onFieldChange('descExperiencia', 'survey_bio')"
                      placeholder="Cuidados básicos, paseos, rescates o voluntariado previo..."
                    ></textarea>
                  </div>

                  <div>
                    <label class="abaq-label" for="p3-motivacion">
                      Motivación principal para sumarse a ABAQ <span class="text-required">*</span>
                    </label>
                    <textarea
                      id="p3-motivacion"
                      name="motivacionAbaq"
                      rows="2"
                      class="abaq-input"
                      style="height: auto; padding: 10px;"
                      [class.input-invalid]="invalidFields['motivacionAbaq']"
                      [(ngModel)]="p3.motivacionAbaq"
                      (ngModelChange)="onFieldChange('motivacionAbaq', 'survey_bio')"
                      placeholder="Fomentar la adopción, aportar al bienestar animal en Querétaro..."
                    ></textarea>
                    @if (invalidFields['motivacionAbaq']) {
                      <span class="field-error-text">⚠️ {{ invalidFields['motivacionAbaq'] }}</span>
                    }
                  </div>
                </div>
              </div>
            </fieldset>

            <!-- Sección 2: Prioridad de Actividades Reordenable (Fiel al React Mockup) -->
            <fieldset id="sec-about-priorities" class="onboarding-fieldset">
              <legend class="onboarding-fieldset-legend" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                <span>02 · Prioridad de Actividades Institucionales</span>
                <span
                  class="section-saved-indicator"
                  [class.status-saving]="getSectionStatus('survey_priorities') === 'saving'"
                  [class.status-saved]="getSectionStatus('survey_priorities') === 'saved'"
                  [class.status-error]="getSectionStatus('survey_priorities') === 'error'"
                  [title]="getSectionStatusTitle('survey_priorities')"
                >
                  <span class="material-symbols-outlined">{{ getSectionIcon('survey_priorities') }}</span>
                  <span>{{ getSectionLabel('survey_priorities') }}</span>
                </span>
              </legend>
              <p style="font-size: 13.5px; color: #64748b; margin-top: 0; margin-bottom: 10px;">
                Ordena las actividades de mayor a menor preferencia usando las flechas para asignarte tareas afines a tu interés:
              </p>

              @if (p1.userType === 'SS') {
                <p style="font-size: 12.5px; color: #0284c7; font-weight: 600; margin-top: 0; margin-bottom: 12px;">
                  ⏱ Las horas acreditables mostradas aplican exclusivamente para la acreditación de tu Servicio Social universitario.
                </p>
              }

              <div style="display: flex; flex-direction: column; gap: 8px;">
                @for (act of p3.rankedActivities; track act; let idx = $index) {
                  <div
                    style="display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; border-radius: 10px; background: #f8fafc; border: 1px solid #cbd5e1;"
                  >
                    <div style="display: flex; align-items: center; gap: 12px; flex: 1; min-width: 0;">
                      <span style="display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; border-radius: 999px; background: #24366f; color: #ffffff; font-size: 12px; font-weight: 800; flex-shrink: 0;">
                        {{ idx + 1 }}
                      </span>
                      <span style="font-size: 13.5px; font-weight: 600; color: #1e293b; line-height: 1.45;">
                        {{ getActivityDisplayText(act) }}
                      </span>
                    </div>

                    <div style="display: flex; gap: 4px; flex-shrink: 0; margin-left: 12px;">
                      <button
                        type="button"
                        (click)="moveActivityUp(idx)"
                        [disabled]="idx === 0"
                        style="background: #ffffff; border: 1px solid #cbd5e1; border-radius: 6px; padding: 4px; cursor: pointer;"
                        [style.opacity]="idx === 0 ? 0.4 : 1"
                        aria-label="Subir prioridad"
                      >
                        <span class="material-symbols-outlined" style="font-size: 18px; color: #1e3a8a;">keyboard_arrow_up</span>
                      </button>
                      <button
                        type="button"
                        (click)="moveActivityDown(idx)"
                        [disabled]="idx === p3.rankedActivities.length - 1"
                        style="background: #ffffff; border: 1px solid #cbd5e1; border-radius: 6px; padding: 4px; cursor: pointer;"
                        [style.opacity]="idx === p3.rankedActivities.length - 1 ? 0.4 : 1"
                        aria-label="Bajar prioridad"
                      >
                        <span class="material-symbols-outlined" style="font-size: 18px; color: #1e3a8a;">keyboard_arrow_down</span>
                      </button>
                    </div>
                  </div>
                }
              </div>
            </fieldset>
          }

          <!-- =========================================================
               FASE 4: DOCUMENTOS POR LIGAS DE NUBE Y CONSENTIMIENTO
               ========================================================= -->
          @if (currentPhase === 4) {
            <div class="onboarding-card-header">
              <h1 class="onboarding-card-title">Documentos en la nube y Consentimiento Legal</h1>
              <p class="onboarding-card-subtitle">
                ABAQ no recibe archivos adjuntos al servidor. Proporciona enlaces compartidos públicos de Google Drive o OneDrive.
              </p>
            </div>

            <!-- Banner Tip de incógnito -->
            <div
              style="margin-bottom: 20px; padding: 14px 18px; border-radius: 12px; background: #eff6ff; border: 1px solid #bfdbfe; color: #1e3a8a;"
              role="note"
            >
              <p style="margin: 0 0 6px; font-weight: 700; font-size: 13.5px;">
                ☁️ Los documentos deben ser enlaces compartidos de Google Drive o OneDrive con acceso de lectura público o institucional permanente.
              </p>
              <p style="margin: 0; font-size: 12.5px; color: #1d4ed8;">
                💡 <strong>Tip importante:</strong> Antes de guardar, abre tus enlaces en una <strong>ventana de incógnito</strong> para confirmar que cualquier revisor de ABAQ pueda abrirlos sin solicitar permisos.
              </p>
            </div>

            <fieldset id="sec-docs-links" class="onboarding-fieldset">
              <legend class="onboarding-fieldset-legend" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                <span>01 · Enlaces a Documentos en la Nube</span>
                <span
                  class="section-saved-indicator"
                  [class.status-saving]="getSectionStatus('docs_links') === 'saving'"
                  [class.status-saved]="getSectionStatus('docs_links') === 'saved'"
                  [class.status-error]="getSectionStatus('docs_links') === 'error'"
                  [title]="getSectionStatusTitle('docs_links')"
                >
                  <span class="material-symbols-outlined">{{ getSectionIcon('docs_links') }}</span>
                  <span>{{ getSectionLabel('docs_links') }}</span>
                </span>
              </legend>

              <div style="display: grid; gap: 14px;">
                <div>
                  <label class="abaq-label" for="doc-ine">
                    1. Identificación oficial vigente (INE o escolar) — Liga compartida
                    <span class="text-required">*</span>
                  </label>
                  <input
                    id="doc-ine"
                    name="cloudIne"
                    type="url"
                    class="abaq-input"
                    [class.input-invalid]="invalidFields['cloudIne']"
                    [(ngModel)]="p4.cloudUrls.ine"
                    (ngModelChange)="onFieldChange('cloudIne', 'docs_links')"
                    placeholder="https://drive.google.com/file/d/... o https://1drv.ms/..."
                  />
                  @if (invalidFields['cloudIne']) {
                    <span class="field-error-text">⚠️ {{ invalidFields['cloudIne'] }}</span>
                  }
                </div>

                <div>
                  <label class="abaq-label" for="doc-cv">
                    2. Currículum Vitae o Ficha de Presentación — Liga compartida
                    <span class="text-required">*</span>
                  </label>
                  <input
                    id="doc-cv"
                    name="cloudCv"
                    type="url"
                    class="abaq-input"
                    [class.input-invalid]="invalidFields['cloudCv']"
                    [(ngModel)]="p4.cloudUrls.cv"
                    (ngModelChange)="onFieldChange('cloudCv', 'docs_links')"
                    placeholder="https://drive.google.com/file/d/..."
                  />
                  @if (invalidFields['cloudCv']) {
                    <span class="field-error-text">⚠️ {{ invalidFields['cloudCv'] }}</span>
                  }
                </div>

                <div>
                  <label class="abaq-label" for="doc-comp">
                    3. {{ p1.userType === 'SS' ? 'Constancia de estudios o Kardex universitario' : 'Comprobante de domicilio o estudios' }} — Liga compartida
                    <span class="text-required">*</span>
                  </label>
                  <input
                    id="doc-comp"
                    name="cloudComp"
                    type="url"
                    class="abaq-input"
                    [class.input-invalid]="invalidFields['cloudComp']"
                    [(ngModel)]="p4.cloudUrls.comprobante"
                    (ngModelChange)="onFieldChange('cloudComp', 'docs_links')"
                    placeholder="https://drive.google.com/file/d/..."
                  />
                  @if (invalidFields['cloudComp']) {
                    <span class="field-error-text">⚠️ {{ invalidFields['cloudComp'] }}</span>
                  }
                </div>
              </div>
            </fieldset>

            <fieldset id="sec-docs-consents" class="onboarding-fieldset">
              <legend class="onboarding-fieldset-legend" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                <span>02 · Consentimiento Legal y Firma Digital</span>
                <span
                  class="section-saved-indicator"
                  [class.status-saving]="getSectionStatus('docs_consents') === 'saving'"
                  [class.status-saved]="getSectionStatus('docs_consents') === 'saved'"
                  [class.status-error]="getSectionStatus('docs_consents') === 'error'"
                  [title]="getSectionStatusTitle('docs_consents')"
                >
                  <span class="material-symbols-outlined">{{ getSectionIcon('docs_consents') }}</span>
                  <span>{{ getSectionLabel('docs_consents') }}</span>
                </span>
              </legend>

              <!-- NOTA SS OBLIGATORIA -->
              @if (p1.userType === 'SS') {
                <div
                  style="margin-bottom: 14px; padding: 12px 14px; border-radius: 10px; background: #fffbeb; border-left: 4px solid #d97706; color: #92400e; font-size: 13.5px; font-weight: 700;"
                >
                  ⚠️ NOTA SS: 2 meses de inactividad no previamente notificada causará la baja automática del programa.
                </div>
              }

              <!-- 5 Casillas de consentimiento legal fiel al React Mockup -->
              <div style="display: flex; flex-direction: column; gap: 12px;">
                <!-- ADVERTENCIA REGLAMENTO OBLIGATORIO -->
                <div
                  style="padding: 14px 18px; border-radius: 12px; background: #fffbeb; border: 1.5px solid #fde68a; color: #92400e;"
                  role="alert"
                >
                  <div style="display: flex; align-items: flex-start; gap: 10px;">
                    <span class="material-symbols-outlined" style="font-size: 22px; color: #d97706; flex-shrink: 0; margin-top: 1px;">gavel</span>
                    <div>
                      <h4 style="margin: 0 0 4px; font-size: 13.5px; font-weight: 800; color: #78350f; text-transform: uppercase;">
                        ⚠️ ACEPTACIÓN VINCULANTE DEL REGLAMENTO INTERNO
                      </h4>
                      <p style="margin: 0; font-size: 12.5px; line-height: 1.5; color: #92400e;">
                        Marcar la casilla de aceptación certifica formalmente la lectura íntegra y comprensión total de cada artículo del reglamento.
                        <strong>Cualquier falta a los lineamientos institucionales o respuestas vagas provocará la cancelación inmediata de tu registro</strong>, debiendo registrarte nuevamente para rehacer el formulario.
                      </p>
                    </div>
                  </div>
                </div>

                <!-- 1. Reglamento -->
                <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 12px; border-radius: 10px; background: #f8fafc; border: 1px solid #e2e8f0;">
                  <label style="display: flex; align-items: center; gap: 10px; cursor: pointer; font-size: 13px; color: #1e293b; font-weight: 600;">
                    <input
                      id="consent-reglamento"
                      type="checkbox"
                      name="consentReglamento"
                      [(ngModel)]="p4.consents.reglamento"
                      (ngModelChange)="onFieldChange('consentReglamento', 'docs_consents')"
                      style="width: 17px; height: 17px; accent-color: #5ca83a;"
                    />
                    <span>Acepto el Reglamento Institucional de ABAQ Querétaro <span class="text-required">*</span></span>
                  </label>
                  <button
                    type="button"
                    (click)="openDocModal('reglamento')"
                    style="background: none; border: none; color: #2563eb; font-size: 12px; font-weight: 700; cursor: pointer; text-decoration: underline;"
                  >
                    Leer reglamento
                  </button>
                </div>
                @if (invalidFields['consentReglamento']) {
                  <span class="field-error-text">⚠️ {{ invalidFields['consentReglamento'] }}</span>
                }

                <!-- 2. Privacidad -->
                <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 12px; border-radius: 10px; background: #f8fafc; border: 1px solid #e2e8f0;">
                  <label style="display: flex; align-items: center; gap: 10px; cursor: pointer; font-size: 13px; color: #1e293b; font-weight: 600;">
                    <input
                      id="consent-privacidad"
                      type="checkbox"
                      name="consentPrivacidad"
                      [(ngModel)]="p4.consents.privacidad"
                      (ngModelChange)="onFieldChange('consentPrivacidad', 'docs_consents')"
                      style="width: 17px; height: 17px; accent-color: #5ca83a;"
                    />
                    <span>He leído y acepto el Aviso de Privacidad y Manejo de Datos <span class="text-required">*</span></span>
                  </label>
                  <button
                    type="button"
                    (click)="openDocModal('privacidad')"
                    style="background: none; border: none; color: #2563eb; font-size: 12px; font-weight: 700; cursor: pointer; text-decoration: underline;"
                  >
                    Leer aviso
                  </button>
                </div>
                @if (invalidFields['consentPrivacidad']) {
                  <span class="field-error-text">⚠️ {{ invalidFields['consentPrivacidad'] }}</span>
                }

                <!-- 3. Ética -->
                <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 12px; border-radius: 10px; background: #f8fafc; border: 1px solid #e2e8f0;">
                  <label style="display: flex; align-items: center; gap: 10px; cursor: pointer; font-size: 13px; color: #1e293b; font-weight: 600;">
                    <input
                      id="consent-etica"
                      type="checkbox"
                      name="consentEtica"
                      [(ngModel)]="p4.consents.etica"
                      (ngModelChange)="onFieldChange('consentEtica', 'docs_consents')"
                      style="width: 17px; height: 17px; accent-color: #5ca83a;"
                    />
                    <span>Me comprometo a cumplir el Código de Ética Institucional <span class="text-required">*</span></span>
                  </label>
                  <button
                    type="button"
                    (click)="openDocModal('etica')"
                    style="background: none; border: none; color: #2563eb; font-size: 12px; font-weight: 700; cursor: pointer; text-decoration: underline;"
                  >
                    Leer código
                  </button>
                </div>
                @if (invalidFields['consentEtica']) {
                  <span class="field-error-text">⚠️ {{ invalidFields['consentEtica'] }}</span>
                }

                <!-- 4. Incógnito -->
                <div style="padding: 10px 12px; border-radius: 10px; background: #f8fafc; border: 1px solid #e2e8f0;">
                  <label style="display: flex; align-items: center; gap: 10px; cursor: pointer; font-size: 13px; color: #1e293b; font-weight: 600;">
                    <input
                      id="consent-incognito"
                      type="checkbox"
                      name="consentIncognito"
                      [(ngModel)]="p4.consents.incognito"
                      (ngModelChange)="onFieldChange('consentIncognito', 'docs_consents')"
                      style="width: 17px; height: 17px; accent-color: #5ca83a;"
                    />
                    <span>He comprobado mis enlaces en ventana de incógnito y confirmo que son accesibles sin solicitar permisos <span class="text-required">*</span></span>
                  </label>
                </div>
                @if (invalidFields['consentIncognito']) {
                  <span class="field-error-text">⚠️ {{ invalidFields['consentIncognito'] }}</span>
                }

                <!-- 5. Consentimiento y Firma Digital -->
                <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 12px; border-radius: 10px; background: #f8fafc; border: 1px solid #e2e8f0;">
                  <label style="display: flex; align-items: center; gap: 10px; cursor: pointer; font-size: 13px; color: #1e293b; font-weight: 600;">
                    <input
                      id="consent-firma"
                      type="checkbox"
                      name="consentFirma"
                      [(ngModel)]="p4.consents.consentimiento"
                      (ngModelChange)="onFieldChange('consentFirma', 'docs_consents')"
                      style="width: 17px; height: 17px; accent-color: #5ca83a;"
                    />
                    <span>Formalización digital mediante aceptación tácita (sustituye firma autógrafa) <span class="text-required">*</span></span>
                  </label>
                  <button
                    type="button"
                    (click)="openDocModal('terminos')"
                    style="background: none; border: none; color: #2563eb; font-size: 12px; font-weight: 700; cursor: pointer; text-decoration: underline;"
                  >
                    Términos
                  </button>
                </div>
                @if (invalidFields['consentFirma']) {
                  <span class="field-error-text">⚠️ {{ invalidFields['consentFirma'] }}</span>
                }
              </div>
            </fieldset>
          }

          <!-- BARRA INFERIOR DE ACCIONES -->
          <div
            id="sec-docs-confirm"
            class="onboarding-form-footer"
            style="display: flex; justify-content: space-between; align-items: center; gap: 12px; margin-top: 24px; padding-top: 18px; border-top: 1px solid #e2e8f0; flex-wrap: wrap;"
          >
            @if (currentPhase > 1) {
              <button
                type="button"
                class="btn-secondary-outline"
                (click)="goToPhase(currentPhase - 1)"
              >
                ← Fase anterior
              </button>
            } @else {
              <a routerLink="/auth/signup" class="btn-secondary-outline" style="text-decoration: none;">
                ← Volver al registro
              </a>
            }

            <button
              id="phase-submit-btn"
              type="submit"
              class="btn-onboarding-primary"
              [disabled]="isSubmitting"
            >
              <span>
                {{
                  currentPhase < 4
                    ? 'Guardar y continuar a Fase 0' + (currentPhase + 1)
                    : isSubmitting
                      ? 'Creando cuenta y expediente en MongoDB...'
                      : 'Finalizar y crear cuenta en ABAQ'
                }}
              </span>
              <span class="material-symbols-outlined">arrow_forward</span>
            </button>
          </div>
        </form>
      </main>
    </div>
  </div>

  <!-- MODAL DE LECTURA DE DOCUMENTOS REGLAMENTARIOS -->
  @if (activeDocModal) {
    <div
      style="position: fixed; inset: 0; background: rgba(15, 23, 42, 0.6); backdrop-filter: blur(4px); z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 20px;"
      role="dialog"
      aria-modal="true"
    >
      <div
        style="background: #ffffff; border-radius: 16px; max-width: 640px; width: 100%; max-height: 80vh; display: flex; flex-direction: column; overflow: hidden; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);"
      >
        <div style="padding: 16px 20px; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center; background: #f8fafc;">
          <h3 style="font-size: 16px; font-weight: 700; color: #1e3a8a; margin: 0;">
            {{ activeDocModal.title }}
          </h3>
          <button
            type="button"
            (click)="closeDocModal()"
            style="background: none; border: none; font-size: 20px; color: #64748b; cursor: pointer;"
          >
            ✕
          </button>
        </div>

        <div style="padding: 20px; overflow-y: auto; font-size: 13.5px; line-height: 1.6; color: #334155; white-space: pre-line;">
          {{ activeDocModal.content }}
        </div>

        <div style="padding: 14px 20px; border-top: 1px solid #e2e8f0; display: flex; justify-content: flex-end; background: #f8fafc;">
          <button
            type="button"
            class="btn-onboarding-primary"
            (click)="closeDocModal()"
            style="padding: 8px 18px; font-size: 13px;"
          >
            Entendido y cerrar
          </button>
        </div>
      </div>
    </div>
  }
</div>
